import { MAX_64_CHARACTERS } from "@/typings/formik"
import { z } from "zod"

export const TemplateCategoryDtoSchema = z
  .object({
    id: z.string(),
    name: z.string(),
  })
  .meta({ id: "TemplateCategoryDtoSchema" })

export const EditTemplateCategoryInputDtoSchema = z
  .object({
    name: z.string().min(1).max(MAX_64_CHARACTERS),
  })
  .meta({ id: "EditTemplateCategoryInputDtoSchema" })

export type EditTemplateCategoryInputDto = z.infer<typeof EditTemplateCategoryInputDtoSchema>
export type TemplateCategoryDto = z.infer<typeof TemplateCategoryDtoSchema>
